"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _zod = require("zod");

var widgetName = 'introduction_bar';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-introduction_bar';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.any();

exports.config = config;

var IntroductionBar = function IntroductionBar() {
  return (0, _preact.h)("section", {
    className: (0, _classnames.default)('full-width', 'Template-brand-cta', 'is-transition--height', 'custom-intro-bar'),
    "data-component": "close-element",
    "data-data": JSON.stringify({
      storageName: 'close--widget-cta',
      parent: '.Template-brand-cta'
    })
  }, (0, _preact.h)("div", {
    className: "cta-widget qa-cta-widget"
  }, (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("span", {
    className: (0, _classnames.default)('icon', 'icon--cross', 'icon--auto-width', 'close', 'js-close--element'),
    "aria-hidden": "true"
  }), (0, _preact.h)("div", {
    className: "col"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('box', 'widget', 'widget--cta')
  }, (0, _preact.h)("div", {
    className: "box__content box__pad"
  }, (0, _preact.h)("ul", {
    className: "list list--float"
  }, (0, _preact.h)("li", {
    className: "list__item"
  }, (0, _preact.h)("span", {
    className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', 'icon--checkmark'),
    "aria-hidden": "true"
  }), (0, _preact.h)("div", {
    className: "list--label"
  }, (0, _preact.h)(_phrase.default, {
    p: "branded.cta.intro.first"
  }))), (0, _preact.h)("li", {
    className: "list__item"
  }, (0, _preact.h)("span", {
    className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', 'icon--checkmark'),
    "aria-hidden": "true"
  }), (0, _preact.h)("div", {
    className: "list--label"
  }, (0, _preact.h)(_phrase.default, {
    p: "branded.cta.intro.second"
  }))), (0, _preact.h)("li", {
    className: "list__item"
  }, (0, _preact.h)("span", {
    className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', 'icon--checkmark'),
    "aria-hidden": "true"
  }), (0, _preact.h)("div", {
    className: "list--label"
  }, (0, _preact.h)(_phrase.default, {
    p: "branded.cta.intro.third"
  })))), (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/topic/new")),
    "data-track": JSON.stringify({
      trigger: 'widget',
      type: 'Topic Initiated'
    }),
    "data-ga-track": JSON.stringify({
      eventCategory: 'Homepage',
      eventAction: 'Create topic clicked',
      eventLabel: {
        Position: 'Introduction widget'
      }
    }),
    className: (0, _classnames.default)('btn--cta', 'btn--new-topic', 'qa-topic-new-button')
  }, (0, _preact.h)(_phrase.default, {
    p: "Ask your question"
  })))), ' '))));
};

var _default = IntroductionBar;
exports.default = _default;